<template>
    <v-container>
        <v-row>
            <v-col align="left">
                <v-img :src="require('@/assets/gifiqr-om-os.jpg')"/>
                <h1>Om gofiqr</h1>
            </v-col>
        </v-row>
        <FourSimpleSteps/>
        <v-divider/>
        <v-row>
            <v-col md="8" align="left">
                <h2>Andre fordele</h2>
                <h3>Kommuniker til dit publikum på flere sprog </h3>
                <p>En kode - mange sprog. Ønsker du fx at engelsk-,  dansk- og tyskregistrerede telefoner skal kunne aflæse dine data på eget sprog, så sker det helt automatisk, hvis du har lagt disse sprogversioner ind i dit gofiqr-univers.</p>

                <h3>Skift indholdet, når det passer dig
                    - behold samme QR-kode</h3>
                <p>Når du har noget nyt på hjerte, når indholdet bliver uaktuelt,  hver dag eller en gang om året - du bestemmer selv, hvornår indholdet på dine QR-koder skal ændres. Det er let, intuitivt og kræver ingen programmering eller kontakt til eksterne bureauer.</p>

                <h3>Tjek statistikken og se, hvad der interesserer din verden</h3>
                <p>gofiqr-universet giver dig mulighed for at se, hvad der interesserer dine medarbejderes og kunder. Via statistikmodulet kan du se, hvad der bliver trykket på af informationer, og du kan bruge det til at styrke din kundeinformation, din interne videndeling og din profilering.</p>

                <v-divider/>

                <h2>new'ish er firmaet bag</h2>
                <p>new’ish er firmaet bag produktet gofiqr: new'ish udtænker innovative it-løsninger, der hjælper dansk erhvervsliv til en lettere hverdag.</p>

                <v-divider/>

                <h2>Q&A</h2>
                <v-card flat link :to="{path: '/q-og-a'}">
                    <p>Klik HER for hyppigt stillede spørgsmål og de bedste svar (funktioner, sikkerhed, firmaoplysninger, priser og meget mere).</p>
                </v-card>

                <v-divider/>
            </v-col>
            <v-col md="4" align="left">
                <ContactForm/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import FourSimpleSteps from "@/components/FourSimpleSteps";
    import ContactForm from "@/components/ContactForm";
    export default {
        name: "AboutPage",
        components: {ContactForm, FourSimpleSteps}
    }
</script>

<style scoped>

</style>